import apiConfig from "../../api-config";

const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

const authorizedGet = async (path) => {
  const token = sessionStorage.getItem("authToken");
  if (!token) throw new Error("No token found");

  const response = await fetch(
    `${api_base_url}/api/${api_key}/get/${path}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const data = await response.json();
  if (!response.ok || data.success === false) {
    throw new Error(
      data.message || data.error || "Unable to load OCI assessment data"
    );
  }
  return data;
};

export const getConfigAssets = async (userId) =>
  authorizedGet(`${userId}/oci/configAsset`);

export const getConfigScanProgress = async (userId) => {
  const response = await authorizedGet(`${userId}/oci/configProgress`);
  return response.data;
};
